import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { ChevronLeftIcon, CheckCircleIcon, BriefcaseIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const PostJob = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    companyWebsite: '',
    companyLogo: '',
    jobTitle: '',
    jobDescription: '',
    jobType: 'full-time',
    workLocation: 'remote',
    minSalary: '',
    maxSalary: '',
    currency: 'USD',
    applicationUrl: '',
    applicationEmail: '',
    skills: [],
    newSkill: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error when field is updated
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };
  const addSkill = () => {
    if (formData.newSkill.trim() && !formData.skills.includes(formData.newSkill.trim())) {
      setFormData({
        ...formData,
        skills: [...formData.skills, formData.newSkill.trim()],
        newSkill: ''
      });
    }
  };
  const removeSkill = (skillToRemove: string) => {
    setFormData({
      ...formData,
      skills: formData.skills.filter(skill => skill !== skillToRemove)
    });
  };
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.companyName.trim()) {
      newErrors.companyName = 'Company name is required';
    }
    if (!formData.jobTitle.trim()) {
      newErrors.jobTitle = 'Job title is required';
    }
    if (!formData.jobDescription.trim()) {
      newErrors.jobDescription = 'Job description is required';
    }
    if (formData.skills.length === 0) {
      newErrors.skills = 'At least one skill is required';
    }
    if (!formData.applicationUrl.trim() && !formData.applicationEmail.trim()) {
      newErrors.applicationUrl = 'Either application URL or email is required';
      newErrors.applicationEmail = 'Either application URL or email is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      // Simulate API call
      setTimeout(() => {
        setIsSubmitting(false);
        setIsSuccess(true);
        // Reset form after success
        setFormData({
          companyName: '',
          companyWebsite: '',
          companyLogo: '',
          jobTitle: '',
          jobDescription: '',
          jobType: 'full-time',
          workLocation: 'remote',
          minSalary: '',
          maxSalary: '',
          currency: 'USD',
          applicationUrl: '',
          applicationEmail: '',
          skills: [],
          newSkill: ''
        });
      }, 1500);
    }
  };
  if (isSuccess) {
    return <div className="bg-[#0F1115] min-h-screen py-20 relative" data-id="element-1420">
        {/* Global Grain Texture */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-50 bg-grain mix-blend-overlay" data-id="element-1421"></div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl relative z-10" data-id="element-1422">
          <div className="bg-[#1a1d24] rounded-2xl border border-gray-800 p-12 text-center" data-id="element-1423">
            <div className="flex flex-col items-center" data-id="element-1424">
              <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mb-6 border border-green-500/30" data-id="element-1425">
                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1426">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1427"></path>
                </svg>
              </div>
              <h2 className="text-3xl font-bold text-white mb-3" data-id="element-1428">
                Job Posted Successfully!
              </h2>
              <p className="text-gray-400 mb-8 max-w-md" data-id="element-1429">
                Your job listing has been submitted and is pending review.
                You'll receive a confirmation email once it's published.
              </p>
              <div className="flex gap-4" data-id="element-1430">
                <Link to="/" data-id="element-1431">
                  <button className="px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full font-medium hover:bg-white/20 transition-all duration-300 border border-white/20" data-id="element-1432">
                    Return Home
                  </button>
                </Link>
                <button onClick={() => setIsSuccess(false)} className="px-6 py-3 bg-[#d73b3e] text-white rounded-full font-medium hover:bg-[#c02f32] transition-all duration-300 shadow-lg" data-id="element-1433">
                  Post Another Job
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="bg-[#0F1115] min-h-screen py-20 relative" data-id="element-1434">
      {/* Global Grain Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-50 bg-grain mix-blend-overlay" data-id="element-1435"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl relative z-10" data-id="element-1436">
        <div className="mb-8" data-id="element-1437">
          <Link to="/" className="inline-flex items-center text-gray-400 hover:text-[#d73b3e] transition-colors" data-id="element-1438">
            <ChevronLeftIcon className="w-5 h-5 mr-1" data-id="element-1439" />
            Back to Home
          </Link>
        </div>

        <div className="text-center mb-12" data-id="element-1440">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#d73b3e]/10 backdrop-blur-sm rounded-full border border-[#d73b3e]/20 mb-6" data-id="element-1441">
            <BriefcaseIcon className="w-4 h-4 text-[#d73b3e]" data-id="element-1442" />
            <span className="text-sm font-medium text-[#d73b3e]" data-id="element-1443">
              Reach 4,500+ Developers
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight" data-id="element-1444">
            Post a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d73b3e] to-orange-500" data-id="element-1445">
              job opening
            </span>
          </h1>
          <p className="text-lg text-gray-400 max-w-xl mx-auto" data-id="element-1446">
            Reach thousands of certified developers by posting your job opening
            on our platform.
          </p>
        </div>

        <div className="bg-[#1a1d24] rounded-2xl border border-gray-800 p-8" data-id="element-1447">
          <form onSubmit={handleSubmit} className="space-y-8" data-id="element-1448">
            {/* Company Information */}
            <div data-id="element-1449">
              <h2 className="text-xl font-semibold text-white mb-6" data-id="element-1450">
                Company Information
              </h2>
              <div className="space-y-4" data-id="element-1451">
                <div data-id="element-1452">
                  <label htmlFor="companyName" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1453">
                    Company Name <span className="text-[#d73b3e]" data-id="element-1454">*</span>
                  </label>
                  <input type="text" id="companyName" name="companyName" value={formData.companyName} onChange={handleChange} className={`w-full px-4 py-3 bg-[#0F1115] border rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all ${errors.companyName ? 'border-[#d73b3e]' : 'border-gray-700'}`} data-id="element-1455" />
                  {errors.companyName && <p className="mt-2 text-sm text-[#d73b3e]" data-id="element-1456">
                      {errors.companyName}
                    </p>}
                </div>
                <div data-id="element-1457">
                  <label htmlFor="companyWebsite" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1458">
                    Company Website
                  </label>
                  <input type="url" id="companyWebsite" name="companyWebsite" value={formData.companyWebsite} onChange={handleChange} placeholder="https://" className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all" data-id="element-1459" />
                </div>
                <div data-id="element-1460">
                  <label htmlFor="companyLogo" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1461">
                    Company Logo URL
                  </label>
                  <input type="url" id="companyLogo" name="companyLogo" value={formData.companyLogo} onChange={handleChange} placeholder="https://" className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all" data-id="element-1462" />
                  <p className="mt-2 text-xs text-gray-500" data-id="element-1463">
                    Provide a URL to your company logo (recommended size:
                    200x200px)
                  </p>
                </div>
              </div>
            </div>

            {/* Job Details */}
            <div className="pt-6 border-t border-gray-800" data-id="element-1464">
              <h2 className="text-xl font-semibold text-white mb-6" data-id="element-1465">
                Job Details
              </h2>
              <div className="space-y-4" data-id="element-1466">
                <div data-id="element-1467">
                  <label htmlFor="jobTitle" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1468">
                    Job Title <span className="text-[#d73b3e]" data-id="element-1469">*</span>
                  </label>
                  <input type="text" id="jobTitle" name="jobTitle" value={formData.jobTitle} onChange={handleChange} className={`w-full px-4 py-3 bg-[#0F1115] border rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all ${errors.jobTitle ? 'border-[#d73b3e]' : 'border-gray-700'}`} placeholder="e.g., Senior Laravel Developer" data-id="element-1470" />
                  {errors.jobTitle && <p className="mt-2 text-sm text-[#d73b3e]" data-id="element-1471">
                      {errors.jobTitle}
                    </p>}
                </div>
                <div data-id="element-1472">
                  <label htmlFor="jobDescription" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1473">
                    Job Description <span className="text-[#d73b3e]" data-id="element-1474">*</span>
                  </label>
                  <textarea id="jobDescription" name="jobDescription" value={formData.jobDescription} onChange={handleChange} rows={6} className={`w-full px-4 py-3 bg-[#0F1115] border rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all resize-vertical ${errors.jobDescription ? 'border-[#d73b3e]' : 'border-gray-700'}`} data-id="element-1475" />
                  {errors.jobDescription && <p className="mt-2 text-sm text-[#d73b3e]" data-id="element-1476">
                      {errors.jobDescription}
                    </p>}
                  <p className="mt-2 text-xs text-gray-500" data-id="element-1477">
                    Provide a detailed description of the role,
                    responsibilities, and requirements.
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1478">
                  <div data-id="element-1479">
                    <label htmlFor="jobType" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1480">
                      Job Type
                    </label>
                    <select id="jobType" name="jobType" value={formData.jobType} onChange={handleChange} className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all" data-id="element-1481">
                      <option value="full-time" data-id="element-1482">Full-time</option>
                      <option value="part-time" data-id="element-1483">Part-time</option>
                      <option value="contract" data-id="element-1484">Contract</option>
                      <option value="freelance" data-id="element-1485">Freelance</option>
                      <option value="internship" data-id="element-1486">Internship</option>
                    </select>
                  </div>
                  <div data-id="element-1487">
                    <label htmlFor="workLocation" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1488">
                      Work Location
                    </label>
                    <select id="workLocation" name="workLocation" value={formData.workLocation} onChange={handleChange} className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all" data-id="element-1489">
                      <option value="remote" data-id="element-1490">Remote</option>
                      <option value="on-site" data-id="element-1491">On-site</option>
                      <option value="hybrid" data-id="element-1492">Hybrid</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1493">
                  <div data-id="element-1494">
                    <label htmlFor="minSalary" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1495">
                      Min Salary
                    </label>
                    <input type="number" id="minSalary" name="minSalary" value={formData.minSalary} onChange={handleChange} className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all" data-id="element-1496" />
                  </div>
                  <div data-id="element-1497">
                    <label htmlFor="maxSalary" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1498">
                      Max Salary
                    </label>
                    <input type="number" id="maxSalary" name="maxSalary" value={formData.maxSalary} onChange={handleChange} className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all" data-id="element-1499" />
                  </div>
                  <div data-id="element-1500">
                    <label htmlFor="currency" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1501">
                      Currency
                    </label>
                    <select id="currency" name="currency" value={formData.currency} onChange={handleChange} className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all" data-id="element-1502">
                      <option value="USD" data-id="element-1503">USD</option>
                      <option value="EUR" data-id="element-1504">EUR</option>
                      <option value="GBP" data-id="element-1505">GBP</option>
                      <option value="CAD" data-id="element-1506">CAD</option>
                      <option value="AUD" data-id="element-1507">AUD</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Required Skills */}
            <div className="pt-6 border-t border-gray-800" data-id="element-1508">
              <h2 className="text-xl font-semibold text-white mb-6" data-id="element-1509">
                Required Skills
              </h2>
              <div className="space-y-4" data-id="element-1510">
                <div data-id="element-1511">
                  <label htmlFor="newSkill" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1512">
                    Add Skills <span className="text-[#d73b3e]" data-id="element-1513">*</span>
                  </label>
                  <div className="flex" data-id="element-1514">
                    <input type="text" id="newSkill" name="newSkill" value={formData.newSkill} onChange={handleChange} className={`flex-grow px-4 py-3 bg-[#0F1115] border rounded-l-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all ${errors.skills ? 'border-[#d73b3e]' : 'border-gray-700'}`} placeholder="e.g., Laravel, PHP, Vue.js" data-id="element-1515" />
                    <button type="button" onClick={addSkill} className="bg-white/10 px-6 py-3 rounded-r-lg hover:bg-white/20 text-white focus:outline-none transition-all border border-l-0 border-gray-700" data-id="element-1516">
                      Add
                    </button>
                  </div>
                  {errors.skills && <p className="mt-2 text-sm text-[#d73b3e]" data-id="element-1517">
                      {errors.skills}
                    </p>}
                </div>
                {formData.skills.length > 0 && <div className="flex flex-wrap gap-2 mt-2" data-id="element-1518">
                    {formData.skills.map((skill, index) => <div key={index} className="bg-white/5 text-gray-300 px-3 py-1.5 rounded-full flex items-center text-sm border border-gray-800" data-id="element-1519">
                        {skill}
                        <button type="button" onClick={() => removeSkill(skill)} className="ml-2 text-gray-400 hover:text-[#d73b3e] focus:outline-none transition-all" data-id="element-1520">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1521">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-1522"></path>
                          </svg>
                        </button>
                      </div>)}
                  </div>}
              </div>
            </div>

            {/* Application Details */}
            <div className="pt-6 border-t border-gray-800" data-id="element-1523">
              <h2 className="text-xl font-semibold text-white mb-6" data-id="element-1524">
                Application Details
              </h2>
              <div className="space-y-4" data-id="element-1525">
                <div data-id="element-1526">
                  <label htmlFor="applicationUrl" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1527">
                    Application URL
                  </label>
                  <input type="url" id="applicationUrl" name="applicationUrl" value={formData.applicationUrl} onChange={handleChange} className={`w-full px-4 py-3 bg-[#0F1115] border rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all ${errors.applicationUrl ? 'border-[#d73b3e]' : 'border-gray-700'}`} placeholder="https://" data-id="element-1528" />
                  {errors.applicationUrl && <p className="mt-2 text-sm text-[#d73b3e]" data-id="element-1529">
                      {errors.applicationUrl}
                    </p>}
                </div>
                <div data-id="element-1530">
                  <label htmlFor="applicationEmail" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1531">
                    Application Email
                  </label>
                  <input type="email" id="applicationEmail" name="applicationEmail" value={formData.applicationEmail} onChange={handleChange} className={`w-full px-4 py-3 bg-[#0F1115] border rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] transition-all ${errors.applicationEmail ? 'border-[#d73b3e]' : 'border-gray-700'}`} data-id="element-1532" />
                  {errors.applicationEmail && <p className="mt-2 text-sm text-[#d73b3e]" data-id="element-1533">
                      {errors.applicationEmail}
                    </p>}
                  <p className="mt-2 text-xs text-gray-500" data-id="element-1534">
                    Provide either an application URL or email where candidates
                    can apply.
                  </p>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="pt-6 border-t border-gray-800" data-id="element-1535">
              <button type="submit" disabled={isSubmitting} className="w-full px-6 py-4 bg-[#d73b3e] text-white rounded-full font-semibold text-lg hover:bg-[#c02f32] transition-all duration-300 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1536">
                {isSubmitting ? 'Submitting...' : 'Post Job'}
              </button>
              <p className="mt-4 text-sm text-center text-gray-400" data-id="element-1537">
                By posting a job, you agree to our{' '}
                <Link to="/terms-of-service" className="text-[#d73b3e] hover:underline" data-id="element-1538">
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link to="/privacy-policy" className="text-[#d73b3e] hover:underline" data-id="element-1539">
                  Privacy Policy
                </Link>
                .
              </p>
            </div>
          </form>
        </div>

        <div className="mt-12 bg-gradient-to-br from-[#d73b3e]/10 to-orange-500/10 rounded-2xl p-8 border border-[#d73b3e]/20" data-id="element-1540">
          <h3 className="text-lg font-semibold text-white mb-4" data-id="element-1541">
            Why post on CertifiedDevs?
          </h3>
          <ul className="space-y-3" data-id="element-1542">
            <li className="flex items-start" data-id="element-1543">
              <CheckCircleIcon className="w-5 h-5 text-[#d73b3e] mt-0.5 mr-3 flex-shrink-0" data-id="element-1544" />
              <span className="text-gray-300" data-id="element-1545">
                Access to 4,500+ certified developers with verified skills
              </span>
            </li>
            <li className="flex items-start" data-id="element-1546">
              <CheckCircleIcon className="w-5 h-5 text-[#d73b3e] mt-0.5 mr-3 flex-shrink-0" data-id="element-1547" />
              <span className="text-gray-300" data-id="element-1548">
                Your job will be featured in our weekly newsletter to developers
              </span>
            </li>
            <li className="flex items-start" data-id="element-1549">
              <CheckCircleIcon className="w-5 h-5 text-[#d73b3e] mt-0.5 mr-3 flex-shrink-0" data-id="element-1550" />
              <span className="text-gray-300" data-id="element-1551">
                30-day listing with options to extend or feature your post
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>;
};
export default PostJob;